import fetchClient, { ApiResponse } from '../api-client'
import { CreatePkgLookupPayload, MeestPkgResponse, PkgLookupItem } from './types'

/**
 * Find USA package by order number via Meest API (proxied by server).
 * Returns package data or throws if not found (404).
 */
export async function findByOrderNumber(orderNumber: string): Promise<MeestPkgResponse> {
  const res = await fetchClient.get<ApiResponse<MeestPkgResponse>>('/pkg-lookup/find-by-order-number', {
    params: { orderNumber: orderNumber.trim() },
  })
  if (!res.data.data) {
    throw new Error('Package not found')
  }
  return res.data.data
}

/**
 * Create a USA package lookup. Send ownerEmail; server looks up userId and stores it.
 */
export async function createPkgLookup(payload: CreatePkgLookupPayload): Promise<PkgLookupItem> {
  const res = await fetchClient.post<ApiResponse<PkgLookupItem>>('/pkg-lookup', payload)
  if (!res.data.data) {
    throw new Error('Failed to create lookup')
  }
  return res.data.data
}

/**
 * List all USA package lookups (admin or USA warehouse only).
 */
export async function getPkgLookups(): Promise<PkgLookupItem[]> {
  const res = await fetchClient.get<ApiResponse<PkgLookupItem[]>>('/pkg-lookup')
  return res.data.data ?? []
}

/**
 * Delete a USA package lookup by id.
 */
export async function deletePkgLookup(id: string): Promise<void> {
  await fetchClient.delete(`/pkg-lookup/${id}`)
}
